import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'dictionary_location'

  static get fields () {
    return {
      id: new UUID(),
      postcode: new STRING(),
      suburb: new STRING(),
      state: new STRING(),
      pobox: new BOOLEAN(),
      country: new STRING(),
      town_state_postcode_country: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME()
    }
  }
}
